import * as React from 'react';
import { useIntl } from 'react-intl';

import { CategoriesSelection } from '@notino/react-styleguide';
import {
  CategoryId,
  ICategory,
} from '@notino/react-styleguide/dist/types/components/molecules/CategoriesSelection/model';
import { WishlistFiltrationGroupType } from '@notino/shared/definitions/types';

import { OverflowFade } from '@components/OverflowFade';
import { useWishlistStore } from '@containers/WishList/store';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { trackCategorySelect } from '../tracking';

import messages from './messages';
import { CategoriesWrapper } from './styled';
import { useGetSelectedFilterItems } from './utils';

const ALL = '';

export const Categories = () => {
  const { formatMessage } = useIntl();
  const { setSelectedNavigationValues } = useWishlistStore((x) => x.actions);
  const selectedNavigationValues = useWishlistStore(
    (x) => x.selectedNavigationValues
  );
  const getSelectedFilterItems = useGetSelectedFilterItems();

  const { getTimeFromInit } = useTrackingContext();

  const filtration = useWishlistStore((x) => x.filtration).find(
    (f) => f.groupType === WishlistFiltrationGroupType.Category
  );

  const categories: ICategory[] =
    filtration?.items.map((item) => ({
      id: item.navigationValue,
      label: item.name,
    })) ?? [];

  const initialCategories = React.useRef(categories);

  const categoriesWithAll: ICategory[] = [
    { id: ALL, label: formatMessage(messages.filtrationAll) },
    ...categories,
  ];

  const selectedCategoryNavValue = selectedNavigationValues.find((val) =>
    getSelectedFilterItems(WishlistFiltrationGroupType.Category)?.some(
      (cv) => cv.navigationValue === val
    )
  );

  const onCategorySelect = (navValue: CategoryId) => {
    setSelectedNavigationValues(
      [
        ...selectedNavigationValues.filter(
          (v) => v !== selectedCategoryNavValue
        ),
        navValue as number, // number or '' (ALL)
      ].filter(Boolean)
    );

    trackCategorySelect({
      timing: getTimeFromInit(),
      name: categories.find((item) => item.id === navValue)?.label || '',
      filters: filtration?.items.map((item) => item.navigationValue) ?? [],
    });
  };

  if (initialCategories.current.length <= 1) {
    return null;
  }

  return (
    <OverflowFade config={{ showArrowCalulationOffset: 12 }}>
      <CategoriesWrapper>
        <CategoriesSelection
          spacesSizeBetweenLabels="0.5rem"
          activeCategoryId={selectedCategoryNavValue ?? ALL}
          categories={categoriesWithAll}
          onCategorySelect={onCategorySelect}
        />
      </CategoriesWrapper>
    </OverflowFade>
  );
};
